import { useLocation } from 'react-router';

export const useRouteQuery = () => new URLSearchParams(useLocation().search);
